import {LitElement, html, css} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import Decimal from './break_infinity.js';
import {FilterView} from './filter-view.js';
import global_css from './global-css.js';
import {formatTime} from './utils.js';

@customElement('ri-log')
export class Log extends FilterView {
  override name = '日志';
  override subtitle = '等等，那是什么？';
  override intersection = true;
  override reverse = true;
  override possibleFilters = new Set([
    {name: 'activity', displayName: 'Activity'},
    {name: 'spell', displayName: 'Spell'},
    {name: 'health', displayName: 'Health'},
    {name: 'unlockable', displayName: 'Unlocks'},
  ]);
  override filters = new Set([]);
  static override styles = [
    ...FilterView.styles,
    css`
      :host {
        overflow: hidden;
      }
      .bottom-container {
        display: flex;
        flex-direction: column;
        overflow: auto;
        flex-wrap: nowrap;
      }
      .bottom-container * {
        margin: 0px;
      }
      .bottom-container *:nth-child(even) {
        background-color: rgb(var(--black, 0, 0, 0), 0.05);
      }
      .bottom-container *:nth-child(odd) {
        background-color: rgb(var(--white, 255, 255, 255), 0.1);
      }
    `,
  ];
}

@customElement('ri-log-entry')
export class LogEntry extends LitElement {
  @property() msg = '';
  type = '';
  important = true;
  @property({type: Number}) datetime = Date.now();
  @property({attribute: false}) tick = new Decimal(0);
  @property({attribute: false}) tags = new Set();
  @property({type: Number}) life: Number = 0;
  duration = 1;
  mergeID: string | undefined;

  static override styles = [
    global_css,
    css`
      :host {
        width: 100%;
        content-visibility: auto;
      }
      .container,
      .header,
      .msg {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: nowrap;
        white-space: nowrap;
      }
      .msg {
        width: 100%;
      }
      .msg.error {
        background-color: #f22; //rgb(var(--alert-color, 255, 0, 0));
        color: rgb(var(--white, 255, 255, 255));
        font-weight: bolder;
      }
    `,
  ];
  override render() {
    setTimeout(() => this.scrollIntoView());
    return html`<div class="container">
      <div class="header">
        ${`${this.life > 0 ? `${this.life}-` : ''} ${formatTime(
          this.tick,
          true
        )} -`}
      </div>
      <div class="msg ${this.tags.has('error') ? 'error' : ''}">
        ${unsafeHTML(this.msg)}
      </div>
    </div>`;
  }
}
